<template>
	<!-- <stack-bar2 :data='data' :chartData='chartData' /> -->
	<!-- <stack-bar2  :chartData='chartData'/> -->

	<DxChart id="chart" :data-source="chartData" @legend-click="onLegendClick">
		<DxCommonSeriesSettings argument-field="titulo" type="stackedbar" />
		<DxSeries value-field="positivos" name="Positivo" color="#f44336" />
		<DxSeries value-field="negativos" name="Negativo" color="#00a65a" />
		<DxSeries
			value-field="inconclusivos"
			name="Inconclusivo"
			color="#ff9800"
		/>
		<DxLegend
			vertical-alignment="top"
			horizontal-alignment="center"
			item-text-position="right"
		/>
		<!-- <DxExport :enabled="true"/> -->
		<DxTooltip :enabled="true" :customize-tooltip="customizeTooltip" />
	</DxChart>
</template>
<script>
	import {
		DxChart,
		DxSeries,
		DxCommonSeriesSettings,
		DxValueAxis,
		DxTitle,
		DxLegend,
		DxExport,
		DxTooltip,
	} from 'devextreme-vue/chart';

	export default {
		props: ['data', 'type'],
		inject: ['vigencia', 'mapVigencia'],
		components: {
			DxChart,
			DxSeries,
			DxCommonSeriesSettings,
			DxValueAxis,
			DxTitle,
			DxLegend,
			DxExport,
			DxTooltip,
		},

		computed: {
			chartData() {
				return this.filterValues(this.type);
			},
		},

		methods: {
			capitalizeFirstLetter(string) {
				return string.charAt(0).toUpperCase() + string.slice(1);
			},

			customizeTooltip(pointInfo) {
				console.log(pointInfo);
				return {
					text: `${
						pointInfo.argumentText
					},  ${this.capitalizeFirstLetter(
						pointInfo.seriesName
					)}s:  ${pointInfo.valueText}`,
					// SKD URCA, Negativos: 333
				};
			},

			filterValues(filter) {
				if (filter == 'todos') {
					return this.data.map((elem) => {
						return {
							frota: elem.frota,
							inconclusivos: +elem.inconclusivos,
							negativos: +elem.negativos,
							positivos: +elem.positivos,
							titulo: elem.titulo,
						};
					});
				}

				let filteredArray = [];

				const convertToNumber = this.data.map((elem) => {
					return {
						frota: elem.frota,
						inconclusivos: +elem.inconclusivos,
						negativos: +elem.negativos,
						positivos: +elem.positivos,
						titulo: elem.titulo,
					};
				});

				convertToNumber.map((e) => {
					if (e.frota.toLowerCase() === filter.toLowerCase())
						filteredArray.push(e);
				});

				return filteredArray;
			},

			onLegendClick({ target: series }) {
				if (series.isVisible()) {
					series.hide();
				} else {
					series.show();
				}
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/exames_dashboard/components/navios.vue